module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dimensions.title":"Dimensions","views.dimensions.caption":"Dimensions are elevated tag keys that are required for tenants with large datasets."}}')
  delete Component.options._Ctor
}
